import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { HiddenInviteCode, HiddenProduct, HiddenRedirect, HiddenXSRF } from '../../common/components/forms';
import IString from '../../common/components/i-string';
import WaitButton from '../../common/components/wait-button';

import { serverToQueryString } from '../../common/util/server-util';
import { translate } from '../../common/i18n/localize';

function PasswordForm(props) {
  const { email } = props;

  const [pending, setPending] = useState(false);
  const query = serverToQueryString();

  return (
    <form method='post' onSubmit={() => setPending(true)}>
      <div className='marginBelow'>
        <strong>{email}</strong>
      </div>

      <input type='hidden' name='email' value={email} />
      <HiddenInviteCode />
      <HiddenRedirect />
      <HiddenXSRF />
      <HiddenProduct />

      <fieldset className='chunk'>
        <input type='password' name='password' placeholder={translate('password.placeholder')} required autoFocus />
      </fieldset>

      <fieldset className='actions noMarginAbove'>
        <WaitButton type='submit' wait={pending} >
          <IString stringKey='password.submit' />
        </WaitButton>
      </fieldset>

      <div className='marginAbove right'>
        <strong><a href={`/forgot_password${query}`}><IString stringKey='password.forgot'></IString></a></strong>
      </div>
    </form>
  );
}

PasswordForm.propTypes = {
  email: PropTypes.string
};

export default PasswordForm;
